function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, watch, computed } from "vue";
import { getDmakerCustomInfo } from "@/api/creative/custom.js";
import { customVersionUpdate } from "@/api/dmaker/custom";
import { defaultInfo } from "@pt/views/pt-entry/components/product-dialog/index";
import ProductDialog from "@pt/views/pt-entry/components/product-dialog/index.vue";
import { Message, Loading } from "element-ui";
import { t } from "@/lang";
import _ from "lodash";
export default defineComponent({
    components: {
        ProductDialog: ProductDialog
    },
    props: {
        visible: {
            type: Boolean,
            required: false
        },
        id: {
            type: Number,
            required: true
        },
        makerType: {
            type: String,
            default: "dMaker"
        },
        tab: {
            type: String,
            default: "normal"
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var loading = ref(false);
        var formItemInfo = ref(defaultInfo);
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        function handleFetchProject(id) {
            return _handleFetchProject.apply(this, arguments);
        }
        function _handleFetchProject() {
            _handleFetchProject = // 获取版本信息
            _asyncToGenerator(regeneratorRuntime.mark(function _callee(id) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return getDmakerCustomInfo({
                                custom_id: id
                            });
                        case 4:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                loading.value = false;
                                formItemInfo.value.name = _.get(res, "data.data.name");
                                formItemInfo.value.platforms = _.get(res, "data.data.apps").length > 1 ? "android,ios" : _.get(res, "data.data.apps").map(function(obj) {
                                    return obj.platform;
                                }).join();
                                formItemInfo.value.app_info = _.get(res, "data.data.apps").map(function(val) {
                                    return _objectSpreadProps(_objectSpread({}, val), {
                                        name: val.app_name,
                                        in_system: 2
                                    });
                                });
                            }
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            loading.value = false;
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8
                    ]
                ]);
            }));
            return _handleFetchProject.apply(this, arguments);
        }
        var saveVersionEdit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(val) {
                var submitLoading, app_info, params, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            submitLoading = Loading.service({
                                lock: true,
                                background: "hsla(0,0%,100%,.9)"
                            });
                            app_info = val.app_info.map(function(e) {
                                return {
                                    app_icon: e.app_icon,
                                    app_name: e.name,
                                    app_url: e.app_url,
                                    package_name: e.package_name,
                                    platform: e.platform
                                };
                            });
                            _ctx.prev = 2;
                            params = {
                                id: props.id,
                                name: val.name,
                                app_info: app_info
                            };
                            _ctx.next = 6;
                            return customVersionUpdate(params);
                        case 6:
                            res = _ctx.sent;
                            submitLoading.close();
                            if (res.data.code === 0) {
                                Message.success("".concat(t("playTurbo.whole.update.successful")));
                                emit("update:visible", false);
                                emit("update-success", params);
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](2);
                            submitLoading.close();
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        11
                    ]
                ]);
            }));
            return function saveVersionEdit(val) {
                return _ref.apply(this, arguments);
            };
        }();
        var initForm = function() {
            emit("update:visible", false);
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                if (props.id > 0) {
                    formItemInfo.value = _.cloneDeep(defaultInfo);
                    handleFetchProject(props.id);
                }
            }
        });
        return {
            loading: loading,
            dialogVisible: dialogVisible,
            formItemInfo: formItemInfo,
            initForm: initForm,
            saveVersionEdit: saveVersionEdit
        };
    }
});
